/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-pass[_ngcontent-%COMP%]{margin:10px}[_nghost-%COMP%]     .material-icons{font-size:18px!important;color:#f39200!important;align-content:center}[_nghost-%COMP%]     input[type=time]::-webkit-calendar-picker-indicator{font-size:18px;-webkit-filter:invert(79%) sepia(55%) saturate(6524%) hue-rotate(7deg) brightness(101%) contrast(105%);filter:invert(79%) sepia(55%) saturate(6524%) hue-rotate(7deg) brightness(101%) contrast(105%)}[_nghost-%COMP%]     .mr-3px{margin-right:3px!important}"];
export { styles as styles };
